/**
 * Sync product media gallery to the variant loaded via URL (?variant=).
 *
 * When a product page is opened with a variant in the query string (e.g. from
 * a collection card swatch), the theme's core JS selects the correct variant
 * but does not always move the media gallery to that variant's image.
 *
 * This mirrors what happens when a visitor clicks a variant option: it calls
 * `mediaGallery.setActiveMedia(mediaId, false)` WITHOUT prepend, so the
 * gallery keeps its natural media order while showing the selected image.
 */
(() => {
  const getVariantIdFromUrl = () => {
    const params = new URLSearchParams(window.location.search);
    return params.get('variant');
  };

  const apply = () => {
    const variantId = getVariantIdFromUrl();
    if (!variantId) return;

    const gallery = document.querySelector('media-gallery[data-section]');
    if (!gallery || typeof gallery.setActiveMedia !== 'function') return;

    const variantSelects = document.querySelector(
      'variant-selects[data-section], variant-radios[data-section]'
    );
    if (!variantSelects) return;

    const variantsJson = variantSelects.querySelector('script[type="application/json"]');
    if (!variantsJson) return;

    let variants;
    try {
      variants = JSON.parse(variantsJson.textContent);
    } catch (e) {
      return;
    }

    const variant = variants.find((v) => String(v.id) === String(variantId));
    if (!variant) return;

    const featuredMedia = variant.featured_media || variant.featured_image;
    const mediaId = featuredMedia ? featuredMedia.id : null;
    if (!mediaId) return;

    const mediaIdString = `${gallery.dataset.section}-${mediaId}`;
    const slide = gallery.querySelector(`[data-media-id="${mediaIdString}"]`);
    if (!slide) return;

    // Defer until after the theme's core JS has initialized the gallery.
    gallery.setActiveMedia(mediaIdString, false);
  };

  // The external theme JS prepends the selected variant's media to the front
  // of the gallery asynchronously (after DOMContentLoaded). To keep the media
  // in its natural order we must run AFTER that happens, so we wait for
  // window 'load' (all deferred scripts + resources) rather than DOMContentLoaded.
  // A readiness poll lets us fire as soon as the gallery is usable.
  const MAX_ATTEMPTS = 20;
  const INTERVAL = 100;

  const start = (attempt = 0) => {
    const gallery = document.querySelector('media-gallery[data-section]');
    if (gallery && typeof gallery.setActiveMedia === 'function') {
      apply();
    } else if (attempt < MAX_ATTEMPTS) {
      setTimeout(() => start(attempt + 1), INTERVAL);
    }
  };

  if (document.readyState === 'loading') {
    window.addEventListener('load', () => setTimeout(start, 100));
  } else {
    setTimeout(start, 100);
  }
})();
